import { useEffect } from 'react';

export const useScrollToHash = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const { pathname, hash } = window.location;

    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }

    const pathParts = pathname.split('/');
    const canonical = `/connectors/${pathParts[2]}/`;
    // Keep the query string (`?utm_*`) when canonicalizing the path or dropping
    // the hash, so campaign attribution survives on connector pages too.
    if (pathname !== canonical || hash) {
      history.replaceState(null, '', `${canonical}${window.location.search}`);
    }
  }, []);
};
